import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setStatisticsAccounts: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};

export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
